<template>
<div class="chapter">
<div class="inner_page">
<p class="timg"><a id="page-iii"></a><span class="center"><img alt="image" class="fullpage" src="images/Art_tit.jpg"/></span></p>
<p class="city"><span class="center"><a href="http://www.orbitbooks.net" target="_blank">orbitbooks.net</a></span></p>
<p class="city1"><span class="center"><a href="http://www.orbitshortfiction.com" target="_blank">orbitshortfiction.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?25d1781f